module.exports = __webpack_public_path__ + "static/media/icon-line-top.734b3d1e.svg";